export var customHeadCodeApiRelativePath = "/helpcenter/headcode";
export var createCustomHeadCodeApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + customHeadCodeApiRelativePath;
    return {
        getCustomHeadCode: function (dto) { return http.get(apiUrl + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : '')); },
        updateCustomHeadCode: function (dto) { return http.put(apiUrl + "/" + dto.locale, dto.data); },
    };
};
//# sourceMappingURL=index.js.map